









import Vue, { PropType } from 'vue';

const themeType = ['red', 'gray'];

export default Vue.extend({
  name: 'GChatMessageBox',
  props: {
    text: {
      type: String as PropType<string>,
      default: '',
    },
    theme: {
      type: String as PropType<string>,
      default: 'primary',
      validator: (prop: string) => themeType.includes(prop),
    },
  },
});
